import React, { useState } from "react";
import { Link } from "react-router-dom";
import { updateCategoryStatus } from "../../../api/testSeries/category";

function CategorySubSubTopicsRow(props) {
  const {
    row,
    index,
    deleteBtnHandler,
    setMode,
    setAddCategoryData,
    setIsAddModalVisible,
    setEditIndex,
    setEditDetails,
  } = props;
  const [status, setStatus] = useState(row.status);

  const changeStatusBtnHandler = async (id, status) => {
    const response = await updateCategoryStatus(id, status);
    console.log(response);
    if (response.status) {
      setStatus(status);
    }
  };
  // console.log(serverBaseUrl+row.image)
  return (
    <tr>
      <td align="center">{index + 1}</td>
      <td align="center">{row.name}</td>
      <td align="center">{row.bookPageNo} </td>
      {/*
      <td align="center">{row.discountAmt} INR</td>
      <td align="center">
        <img src={fileBaseUrl + row.image} style={{ height: 50, width: 50 }} />
      </td> */}
      {/* <td align="center">{status}</td> */}
      <td align="center">
        <button
          aria-label="delete"
          onClick={() => deleteBtnHandler(row.id, index)}
          className="btn btn-danger mr-1"
        >
          Delete
        </button>
        <button
          aria-label="edit"
          onClick={() => {
            setEditIndex(index);
            // setEditDetails(serverBaseUrl+row.image)
            setAddCategoryData(row);
            setMode("edit");
            setIsAddModalVisible(true);
          }}
          className="btn btn-dark mr-1"
        >
          Edit
        </button>
        {/* {status == "INACTIVE" ? (
          <button
            aria-label="delete"
            onClick={() => changeStatusBtnHandler(row.id, "ACTIVE")}
            className="btn btn-warning mr-1"
          >
            Mark active
          </button>
        ) : (
          <button
            aria-label="delete"
            onClick={() => changeStatusBtnHandler(row.id, "INACTIVE")}
            className="btn btn-success mr-1"
          >
            Mark Inactive
          </button>
        )}
        <Link
          to={"/subcategory/" + row.id}
          aria-label="delete"
          className="btn btn-primary mr-1"
        >
          All Tests
        </Link>
        <Link
          to={"/mocktestStats/" + row.id}
          aria-label="delete"
          className="btn btn-primary mr-1"
        >
          Analysis
        </Link> */}
        {/* <Link
          to={"/topics/" + row.id}
          //   aria-label="delete"
          className="btn btn-primary mr-1"
        >
          Sub-Sub-Topics
        </Link> */}
      </td>
    </tr>
  );
}

export default CategorySubSubTopicsRow;
